import { render, staticRenderFns } from "./OrderListShipping.vue?vue&type=template&id=5230cb47&scoped=true&"
import script from "./OrderListShipping.vue?vue&type=script&lang=js&"
export * from "./OrderListShipping.vue?vue&type=script&lang=js&"
import style0 from "./OrderListShipping.vue?vue&type=style&index=0&id=5230cb47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230cb47",
  null
  
)

export default component.exports